import { useAuth } from "src/auth/AuthProvider"

export const isEmpty = (strValue: string | undefined) => {
    return (!strValue || strValue.trim() === "" || (strValue.trim()).length === 0)
}

export const getRequestConfig = () => {
    const auth = useAuth()
    let jwtToken = auth.user.signInUserSession.idToken.jwtToken
    return {
        headers: {
            "Content-type": "application/json",
            "Authorization": `Bearer ${jwtToken}`,
        },
    };
}